import { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Form } from 'redux-form';

import PickupLocationForm from 'common/components/address/PickupLocationForm';
import { FormError } from 'common/components/layout';
import { isPreSale } from 'common/helpers/featureFlags';
import { getClubList } from 'common/helpers/miscHelper';
import { updateClubSignup } from 'redux/clubSignup/actions';
import { asyncValidateEmailNotArray } from 'redux/customer/helpers';
import { listPickupLocations } from 'redux/inventoryLocations/actions';

import Email from './components/Email';
import { validateForNotLoggedInCustomerPickup } from './validators';

class Customer extends Component {
  componentDidMount() {
    const { props } = this;
    props.listPickupLocations();
  }

  handleSubmit = (form) => {
    const { props } = this;
    const data = transformData(form);
    const clubSignup = {
      email: data.email,
      isSubscribe: data.isSubscribe,
      orderDeliveryMethod: 'Pickup',
      pickupInventoryLocationId: data.inventoryLocationId,
      giftMessage: null,
      shippingInstructions: null
    };
    props.updateClubSignup(clubSignup);
  };

  handleShip = (e) => {
    e.preventDefault();
    const { onShip } = this.props;
    onShip();
  };

  render() {
    const { handleSubmit, form, settings, formValues } = this.props;
    const { inventoryLocation } = this.props;
    if (!inventoryLocation.data || !formValues) {
      return null;
    }
    let clubSelection = 'club selection';
    if (isPreSale()) {
      clubSelection = 'pre-sale selection';
    }
    return (
      <Form
        onSubmit={handleSubmit(this.handleSubmit)}
        className="c7-form"
        method="post"
      >
        <FormError formName={form} />
        <Email />
        <p>&nbsp;</p>
        <div className="c7-checkout__content__title">
          <h3>Pickup address</h3>
          <a
            className="c7-checkout__content__title__ship"
            onClick={this.handleShip}
          >
            I prefer to have my club shipment shipped
          </a>
        </div>
        <PickupLocationForm
          formValues={formValues}
          inventoryLocation={inventoryLocation}
        />
        <div className="c7-checkout__content__buttons">
          <button className="c7-button" type="submit">
            Continue to payment information
          </button>
          <a href={`${getClubList(settings)}`}>Return to {clubSelection}</a>
        </div>
      </Form>
    );
  }
}

const transformData = (values) => {
  const data = {
    email: values.email,
    inventoryLocationId: values.inventoryLocationId,
    isSubscribe: values.isSubscribe || false
  };
  return data;
};

const validate = (values, ownProps) => {
  const data = transformData(values);
  const errors = validateForNotLoggedInCustomerPickup(data, ownProps.settings);
  return errors;
};

const getFirstInventoryLocation = (inventoryLocation) => {
  if (!inventoryLocation || !inventoryLocation.data) {
    return null;
  }
  const inventoryLocationIdArray = Object.keys(inventoryLocation.data);

  return inventoryLocationIdArray[0];
};

const mapStateToProps = (state) => {
  const clubSignup = state.clubSignup.data;
  const initialValues = {};
  if (clubSignup) {
    initialValues.email = clubSignup.email;
    initialValues.isSubscribe = clubSignup.isSubscribe;
    initialValues.inventoryLocationId = clubSignup.pickupInventoryLocationId;
  }
  if (!initialValues.inventoryLocationId) {
    initialValues.inventoryLocationId = getFirstInventoryLocation(
      state.inventoryLocation
    );
  }
  return {
    initialValues,
    settings: state.setting,
    inventoryLocation: state.inventoryLocation,
    formValues:
      state.form.customerNotLoggedInPickup &&
      state.form.customerNotLoggedInPickup.values
  };
};

const asyncValidate = (values) => {
  const { email } = values;
  return asyncValidateEmailNotArray(email).then((errors) => {
    if (errors) {
      throw errors;
    }
  });
};

Customer = reduxForm({
  form: 'customerNotLoggedInPickup',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate,
  asyncValidate,
  asyncBlurFields: ['email']
})(Customer);

export default connect(mapStateToProps, {
  updateClubSignup,
  listPickupLocations
})(Customer);
